import type { QueryClient } from '@tanstack/react-query';
import { isLoopOverviewQueryKey } from '@/features/objectives/queryKeys';

export const invalidateLoopOverview = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ predicate: ({ queryKey }) => isLoopOverviewQueryKey(queryKey) });
